var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "찜한 공고 관리",
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "contents"
  }, [_vm.items.length ? [_c('div', {
    staticClass: "applied-cards"
  }, _vm._l(_vm.items, function (item) {
    var _item$recruitment, _item$recruitment$com, _item$recruitment$com2, _item$recruitment2, _item$recruitment2$co, _item$recruitment2$co2, _item$recruitment3, _item$recruitment3$co, _item$recruitment4, _item$recruitment4$co, _item$recruitment5, _item$recruitment6, _item$recruitment7, _item$recruitment7$em, _item$recruitment8, _item$recruitment9;
    return _c('v-card', {
      key: item._id,
      staticClass: "applied-card",
      attrs: {
        "rounded": "lg",
        "outlined": ""
      }
    }, [_c('v-row', {
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      staticClass: "border-md-end min-w-md-200px min-w-lg-280px",
      attrs: {
        "cols": "12",
        "md": "auto"
      }
    }, [_c('v-layout', {
      staticClass: "w-100 h-100 pa-20",
      attrs: {
        "justify-center": "",
        "align-center": ""
      }
    }, [_c('v-img', {
      attrs: {
        "aspect-ratio": 166 / 36,
        "width": "166",
        "height": "36",
        "max-width": "166",
        "contain": "",
        "src": item === null || item === void 0 ? void 0 : (_item$recruitment = item.recruitment) === null || _item$recruitment === void 0 ? void 0 : (_item$recruitment$com = _item$recruitment.company) === null || _item$recruitment$com === void 0 ? void 0 : (_item$recruitment$com2 = _item$recruitment$com.logo) === null || _item$recruitment$com2 === void 0 ? void 0 : _item$recruitment$com2.url
      }
    }, [_c('v-fade-transition', [_c('v-overlay', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !(item !== null && item !== void 0 && (_item$recruitment2 = item.recruitment) !== null && _item$recruitment2 !== void 0 && (_item$recruitment2$co = _item$recruitment2.company) !== null && _item$recruitment2$co !== void 0 && (_item$recruitment2$co2 = _item$recruitment2$co.logo) !== null && _item$recruitment2$co2 !== void 0 && _item$recruitment2$co2.url),
        expression: "!item?.recruitment?.company?.logo?.url"
      }],
      attrs: {
        "absolute": "",
        "light": "",
        "color": "white"
      }
    }, [_c('image-overlay', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$recruitment3 = item.recruitment) === null || _item$recruitment3 === void 0 ? void 0 : (_item$recruitment3$co = _item$recruitment3.company) === null || _item$recruitment3$co === void 0 ? void 0 : _item$recruitment3$co.name))])], 1)], 1)], 1)], 1)], 1), _c('v-col', {
      staticClass: "applied-card__info",
      attrs: {
        "cols": "12",
        "md": ""
      }
    }, [_c('div', {
      staticClass: "pa-20 pa-md-24"
    }, [_c('p', {
      staticClass: "page-text page-text--sm primary--text mb-4"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$recruitment4 = item.recruitment) === null || _item$recruitment4 === void 0 ? void 0 : (_item$recruitment4$co = _item$recruitment4.company) === null || _item$recruitment4$co === void 0 ? void 0 : _item$recruitment4$co.name))]), _c('div', {
      staticClass: "mb-8 mb-lg-16"
    }, [_c('v-row', {
      staticClass: "row--x-small",
      attrs: {
        "no-gutters": "",
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('a', {
      staticClass: "page-text--lg font-wieght-medium",
      attrs: {
        "href": `/recruitments/${item === null || item === void 0 ? void 0 : (_item$recruitment5 = item.recruitment) === null || _item$recruitment5 === void 0 ? void 0 : _item$recruitment5._id}`,
        "rel": "noopener noreferrer"
      }
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$recruitment6 = item.recruitment) === null || _item$recruitment6 === void 0 ? void 0 : _item$recruitment6.subject) + " ")])]), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('like-btn', {
      attrs: {
        "params": {
          _recruitment: item._recruitment,
          type: _vm.USER_LIKE_TYPES.RECRUITMENT.value
        }
      },
      on: {
        "removed": function ($event) {
          return _vm.remove(item);
        }
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var active = _ref.active,
            toggle = _ref.toggle;
          return [_c('v-btn', {
            attrs: {
              "icon": "",
              "text": "",
              "small": "",
              "color": active ? 'yellow darken-1' : undefined
            },
            on: {
              "!click": function ($event) {
                $event.stopPropagation();
                $event.preventDefault();
                return toggle.apply(null, arguments);
              }
            }
          }, [_c('v-icon', [_vm._v(_vm._s(active ? "mdi-star" : "mdi-star-outline"))])], 1)];
        }
      }], null, true)
    })], 1)], 1)], 1), item !== null && item !== void 0 && (_item$recruitment7 = item.recruitment) !== null && _item$recruitment7 !== void 0 && (_item$recruitment7$em = _item$recruitment7.employment) !== null && _item$recruitment7$em !== void 0 && _item$recruitment7$em.typesTexts ? _c('v-chip-group', {
      staticClass: "mb-4"
    }, _vm._l(item.recruitment.employment.typesTexts, function (text) {
      return _c('v-chip', {
        key: text,
        attrs: {
          "small": "",
          "outlined": "",
          "color": "grey-d"
        }
      }, [_c('span', {
        staticClass: "grey-6--text"
      }, [_vm._v(" " + _vm._s(text) + " ")])]);
    }), 1) : _vm._e(), _c('p', {
      staticClass: "page-text grey-6--text ellip mb-8 mb-lg-16"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$recruitment8 = item.recruitment) === null || _item$recruitment8 === void 0 ? void 0 : _item$recruitment8.summary) + " ")]), _c('recruitment-view-application', {
      attrs: {
        "application": item === null || item === void 0 ? void 0 : (_item$recruitment9 = item.recruitment) === null || _item$recruitment9 === void 0 ? void 0 : _item$recruitment9.application
      }
    })], 1)])], 1)], 1);
  }), 1), _c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })] : [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요, 사용자님. "), _c('br'), _vm._v(" 찜한 공고가 없습니다. ")]), _c('v-btn', {
    attrs: {
      "href": "/recruitments",
      "text": "",
      "height": "auto",
      "color": "transparent"
    }
  }, [_c('span', {
    staticClass: "grey-9--text"
  }, [_vm._v("채용공고 보러가기")])])], 1)]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }